// Generated by app/tools/gen-timezones.mjs from IANA tzdb 2026c.
// Do not edit by hand — re-run the generator instead.

/** A country and the IANA zones the tz database files under it. */
export interface CountryZones {
  /** ISO-3166 alpha-2. */
  code: string;
  /** English name, as the tz database spells it. */
  name: string;
  zones: ZoneEntry[];
}

export interface ZoneEntry {
  /** IANA identifier, e.g. `Asia/Kolkata`. */
  id: string;
  /** Which part of the country it covers, blank when the country has one zone. */
  region: string;
}

export const TZDB_VERSION = "2026c";

/** Sorted by country name, zones in the order the tz database lists them. */
export const COUNTRY_ZONES: CountryZones[] = [
  {
    "code": "AF",
    "name": "Afghanistan",
    "zones": [
      {
        "id": "Asia/Kabul",
        "region": ""
      }
    ]
  },
  {
    "code": "AX",
    "name": "Åland Islands",
    "zones": [
      {
        "id": "Europe/Mariehamn",
        "region": ""
      }
    ]
  },
  {
    "code": "AL",
    "name": "Albania",
    "zones": [
      {
        "id": "Europe/Tirane",
        "region": ""
      }
    ]
  },
  {
    "code": "DZ",
    "name": "Algeria",
    "zones": [
      {
        "id": "Africa/Algiers",
        "region": ""
      }
    ]
  },
  {
    "code": "AD",
    "name": "Andorra",
    "zones": [
      {
        "id": "Europe/Andorra",
        "region": ""
      }
    ]
  },
  {
    "code": "AO",
    "name": "Angola",
    "zones": [
      {
        "id": "Africa/Luanda",
        "region": ""
      }
    ]
  },
  {
    "code": "AI",
    "name": "Anguilla",
    "zones": [
      {
        "id": "America/Anguilla",
        "region": ""
      }
    ]
  },
  {
    "code": "AQ",
    "name": "Antarctica",
    "zones": [
      {
        "id": "Antarctica/McMurdo",
        "region": "New Zealand time - McMurdo, South Pole"
      },
      {
        "id": "Antarctica/Casey",
        "region": "Casey"
      },
      {
        "id": "Antarctica/Davis",
        "region": "Davis"
      },
      {
        "id": "Antarctica/DumontDUrville",
        "region": "Dumont-d'Urville"
      },
      {
        "id": "Antarctica/Mawson",
        "region": "Mawson"
      },
      {
        "id": "Antarctica/Palmer",
        "region": "Palmer"
      },
      {
        "id": "Antarctica/Rothera",
        "region": "Rothera"
      },
      {
        "id": "Antarctica/Syowa",
        "region": "Syowa"
      },
      {
        "id": "Antarctica/Troll",
        "region": "Troll"
      },
      {
        "id": "Antarctica/Vostok",
        "region": "Vostok"
      }
    ]
  },
  {
    "code": "AG",
    "name": "Antigua & Barbuda",
    "zones": [
      {
        "id": "America/Antigua",
        "region": ""
      }
    ]
  },
  {
    "code": "AR",
    "name": "Argentina",
    "zones": [
      {
        "id": "America/Argentina/Buenos_Aires",
        "region": "Buenos Aires (BA, CF)"
      },
      {
        "id": "America/Argentina/Cordoba",
        "region": "Argentina (most areas: CB, CC, CN, ER, FM, MN, SE, SF)"
      },
      {
        "id": "America/Argentina/Salta",
        "region": "Salta (SA, LP, NQ, RN)"
      },
      {
        "id": "America/Argentina/Jujuy",
        "region": "Jujuy (JY)"
      },
      {
        "id": "America/Argentina/Tucuman",
        "region": "Tucuman (TM)"
      },
      {
        "id": "America/Argentina/Catamarca",
        "region": "Catamarca (CT), Chubut (CH)"
      },
      {
        "id": "America/Argentina/La_Rioja",
        "region": "La Rioja (LR)"
      },
      {
        "id": "America/Argentina/San_Juan",
        "region": "San Juan (SJ)"
      },
      {
        "id": "America/Argentina/Mendoza",
        "region": "Mendoza (MZ)"
      },
      {
        "id": "America/Argentina/San_Luis",
        "region": "San Luis (SL)"
      },
      {
        "id": "America/Argentina/Rio_Gallegos",
        "region": "Santa Cruz (SC)"
      },
      {
        "id": "America/Argentina/Ushuaia",
        "region": "Tierra del Fuego (TF)"
      }
    ]
  },
  {
    "code": "AM",
    "name": "Armenia",
    "zones": [
      {
        "id": "Asia/Yerevan",
        "region": ""
      }
    ]
  },
  {
    "code": "AW",
    "name": "Aruba",
    "zones": [
      {
        "id": "America/Aruba",
        "region": ""
      }
    ]
  },
  {
    "code": "AU",
    "name": "Australia",
    "zones": [
      {
        "id": "Australia/Lord_Howe",
        "region": "Lord Howe Island"
      },
      {
        "id": "Antarctica/Macquarie",
        "region": "Macquarie Island"
      },
      {
        "id": "Australia/Hobart",
        "region": "Tasmania"
      },
      {
        "id": "Australia/Melbourne",
        "region": "Victoria"
      },
      {
        "id": "Australia/Sydney",
        "region": "New South Wales (most areas)"
      },
      {
        "id": "Australia/Broken_Hill",
        "region": "New South Wales (Yancowinna)"
      },
      {
        "id": "Australia/Brisbane",
        "region": "Queensland (most areas)"
      },
      {
        "id": "Australia/Lindeman",
        "region": "Queensland (Whitsunday Islands)"
      },
      {
        "id": "Australia/Adelaide",
        "region": "South Australia"
      },
      {
        "id": "Australia/Darwin",
        "region": "Northern Territory"
      },
      {
        "id": "Australia/Perth",
        "region": "Western Australia (most areas)"
      },
      {
        "id": "Australia/Eucla",
        "region": "Western Australia (Eucla)"
      }
    ]
  },
  {
    "code": "AT",
    "name": "Austria",
    "zones": [
      {
        "id": "Europe/Vienna",
        "region": ""
      }
    ]
  },
  {
    "code": "AZ",
    "name": "Azerbaijan",
    "zones": [
      {
        "id": "Asia/Baku",
        "region": ""
      }
    ]
  },
  {
    "code": "BS",
    "name": "Bahamas",
    "zones": [
      {
        "id": "America/Nassau",
        "region": ""
      }
    ]
  },
  {
    "code": "BH",
    "name": "Bahrain",
    "zones": [
      {
        "id": "Asia/Bahrain",
        "region": ""
      }
    ]
  },
  {
    "code": "BD",
    "name": "Bangladesh",
    "zones": [
      {
        "id": "Asia/Dhaka",
        "region": ""
      }
    ]
  },
  {
    "code": "BB",
    "name": "Barbados",
    "zones": [
      {
        "id": "America/Barbados",
        "region": ""
      }
    ]
  },
  {
    "code": "BY",
    "name": "Belarus",
    "zones": [
      {
        "id": "Europe/Minsk",
        "region": ""
      }
    ]
  },
  {
    "code": "BE",
    "name": "Belgium",
    "zones": [
      {
        "id": "Europe/Brussels",
        "region": ""
      }
    ]
  },
  {
    "code": "BZ",
    "name": "Belize",
    "zones": [
      {
        "id": "America/Belize",
        "region": ""
      }
    ]
  },
  {
    "code": "BJ",
    "name": "Benin",
    "zones": [
      {
        "id": "Africa/Porto-Novo",
        "region": ""
      }
    ]
  },
  {
    "code": "BM",
    "name": "Bermuda",
    "zones": [
      {
        "id": "Atlantic/Bermuda",
        "region": ""
      }
    ]
  },
  {
    "code": "BT",
    "name": "Bhutan",
    "zones": [
      {
        "id": "Asia/Thimphu",
        "region": ""
      }
    ]
  },
  {
    "code": "BO",
    "name": "Bolivia",
    "zones": [
      {
        "id": "America/La_Paz",
        "region": ""
      }
    ]
  },
  {
    "code": "BA",
    "name": "Bosnia & Herzegovina",
    "zones": [
      {
        "id": "Europe/Sarajevo",
        "region": ""
      }
    ]
  },
  {
    "code": "BW",
    "name": "Botswana",
    "zones": [
      {
        "id": "Africa/Gaborone",
        "region": ""
      }
    ]
  },
  {
    "code": "BR",
    "name": "Brazil",
    "zones": [
      {
        "id": "America/Noronha",
        "region": "Atlantic islands"
      },
      {
        "id": "America/Belem",
        "region": "Para (east), Amapa"
      },
      {
        "id": "America/Fortaleza",
        "region": "Brazil (northeast: MA, PI, CE, RN, PB)"
      },
      {
        "id": "America/Recife",
        "region": "Pernambuco"
      },
      {
        "id": "America/Araguaina",
        "region": "Tocantins"
      },
      {
        "id": "America/Maceio",
        "region": "Alagoas, Sergipe"
      },
      {
        "id": "America/Bahia",
        "region": "Bahia"
      },
      {
        "id": "America/Sao_Paulo",
        "region": "Brazil (southeast: GO, DF, MG, ES, RJ, SP, PR, SC, RS)"
      },
      {
        "id": "America/Campo_Grande",
        "region": "Mato Grosso do Sul"
      },
      {
        "id": "America/Cuiaba",
        "region": "Mato Grosso"
      },
      {
        "id": "America/Santarem",
        "region": "Para (west)"
      },
      {
        "id": "America/Porto_Velho",
        "region": "Rondonia"
      },
      {
        "id": "America/Boa_Vista",
        "region": "Roraima"
      },
      {
        "id": "America/Manaus",
        "region": "Amazonas (east)"
      },
      {
        "id": "America/Eirunepe",
        "region": "Amazonas (west)"
      },
      {
        "id": "America/Rio_Branco",
        "region": "Acre"
      }
    ]
  },
  {
    "code": "GB",
    "name": "Britain (UK)",
    "zones": [
      {
        "id": "Europe/London",
        "region": ""
      }
    ]
  },
  {
    "code": "IO",
    "name": "British Indian Ocean Territory",
    "zones": [
      {
        "id": "Indian/Chagos",
        "region": ""
      }
    ]
  },
  {
    "code": "BN",
    "name": "Brunei",
    "zones": [
      {
        "id": "Asia/Brunei",
        "region": ""
      }
    ]
  },
  {
    "code": "BG",
    "name": "Bulgaria",
    "zones": [
      {
        "id": "Europe/Sofia",
        "region": ""
      }
    ]
  },
  {
    "code": "BF",
    "name": "Burkina Faso",
    "zones": [
      {
        "id": "Africa/Ouagadougou",
        "region": ""
      }
    ]
  },
  {
    "code": "BI",
    "name": "Burundi",
    "zones": [
      {
        "id": "Africa/Bujumbura",
        "region": ""
      }
    ]
  },
  {
    "code": "KH",
    "name": "Cambodia",
    "zones": [
      {
        "id": "Asia/Phnom_Penh",
        "region": ""
      }
    ]
  },
  {
    "code": "CM",
    "name": "Cameroon",
    "zones": [
      {
        "id": "Africa/Douala",
        "region": ""
      }
    ]
  },
  {
    "code": "CA",
    "name": "Canada",
    "zones": [
      {
        "id": "America/St_Johns",
        "region": "Newfoundland, Labrador (SE)"
      },
      {
        "id": "America/Halifax",
        "region": "Atlantic - NS (most areas), PE"
      },
      {
        "id": "America/Glace_Bay",
        "region": "Atlantic - NS (Cape Breton)"
      },
      {
        "id": "America/Moncton",
        "region": "Atlantic - New Brunswick"
      },
      {
        "id": "America/Goose_Bay",
        "region": "Atlantic - Labrador (most areas)"
      },
      {
        "id": "America/Blanc-Sablon",
        "region": "AST - QC (Lower North Shore)"
      },
      {
        "id": "America/Toronto",
        "region": "Eastern - ON & QC (most areas)"
      },
      {
        "id": "America/Iqaluit",
        "region": "Eastern - NU (most areas)"
      },
      {
        "id": "America/Atikokan",
        "region": "EST - ON (Atikokan), NU (Coral H)"
      },
      {
        "id": "America/Winnipeg",
        "region": "Central - ON (west), Manitoba"
      },
      {
        "id": "America/Resolute",
        "region": "Central - NU (Resolute)"
      },
      {
        "id": "America/Rankin_Inlet",
        "region": "Central - NU (central)"
      },
      {
        "id": "America/Regina",
        "region": "CST - SK (most areas)"
      },
      {
        "id": "America/Swift_Current",
        "region": "CST - SK (midwest)"
      },
      {
        "id": "America/Edmonton",
        "region": "CST - AB, BC(E), NT(E), SK(W)"
      },
      {
        "id": "America/Cambridge_Bay",
        "region": "Mountain - NU (west)"
      },
      {
        "id": "America/Inuvik",
        "region": "Mountain - NT (west)"
      },
      {
        "id": "America/Vancouver",
        "region": "MST - BC (most areas)"
      },
      {
        "id": "America/Creston",
        "region": "MST - BC (Creston)"
      },
      {
        "id": "America/Dawson_Creek",
        "region": "MST - BC (Dawson Cr, Ft St John)"
      },
      {
        "id": "America/Fort_Nelson",
        "region": "MST - BC (Ft Nelson)"
      },
      {
        "id": "America/Whitehorse",
        "region": "MST - Yukon (east)"
      },
      {
        "id": "America/Dawson",
        "region": "MST - Yukon (west)"
      }
    ]
  },
  {
    "code": "CV",
    "name": "Cape Verde",
    "zones": [
      {
        "id": "Atlantic/Cape_Verde",
        "region": ""
      }
    ]
  },
  {
    "code": "BQ",
    "name": "Caribbean NL",
    "zones": [
      {
        "id": "America/Kralendijk",
        "region": ""
      }
    ]
  },
  {
    "code": "KY",
    "name": "Cayman Islands",
    "zones": [
      {
        "id": "America/Cayman",
        "region": ""
      }
    ]
  },
  {
    "code": "CF",
    "name": "Central African Rep.",
    "zones": [
      {
        "id": "Africa/Bangui",
        "region": ""
      }
    ]
  },
  {
    "code": "TD",
    "name": "Chad",
    "zones": [
      {
        "id": "Africa/Ndjamena",
        "region": ""
      }
    ]
  },
  {
    "code": "CL",
    "name": "Chile",
    "zones": [
      {
        "id": "America/Santiago",
        "region": "most of Chile"
      },
      {
        "id": "America/Coyhaique",
        "region": "Aysen Region"
      },
      {
        "id": "America/Punta_Arenas",
        "region": "Magallanes Region"
      },
      {
        "id": "Pacific/Easter",
        "region": "Easter Island"
      }
    ]
  },
  {
    "code": "CN",
    "name": "China",
    "zones": [
      {
        "id": "Asia/Shanghai",
        "region": "Beijing Time"
      },
      {
        "id": "Asia/Urumqi",
        "region": "Xinjiang Time"
      }
    ]
  },
  {
    "code": "CX",
    "name": "Christmas Island",
    "zones": [
      {
        "id": "Indian/Christmas",
        "region": ""
      }
    ]
  },
  {
    "code": "CC",
    "name": "Cocos (Keeling) Islands",
    "zones": [
      {
        "id": "Indian/Cocos",
        "region": ""
      }
    ]
  },
  {
    "code": "CO",
    "name": "Colombia",
    "zones": [
      {
        "id": "America/Bogota",
        "region": ""
      }
    ]
  },
  {
    "code": "KM",
    "name": "Comoros",
    "zones": [
      {
        "id": "Indian/Comoro",
        "region": ""
      }
    ]
  },
  {
    "code": "CD",
    "name": "Congo (Dem. Rep.)",
    "zones": [
      {
        "id": "Africa/Kinshasa",
        "region": "Dem. Rep. of Congo (west)"
      },
      {
        "id": "Africa/Lubumbashi",
        "region": "Dem. Rep. of Congo (east)"
      }
    ]
  },
  {
    "code": "CG",
    "name": "Congo (Rep.)",
    "zones": [
      {
        "id": "Africa/Brazzaville",
        "region": ""
      }
    ]
  },
  {
    "code": "CK",
    "name": "Cook Islands",
    "zones": [
      {
        "id": "Pacific/Rarotonga",
        "region": ""
      }
    ]
  },
  {
    "code": "CR",
    "name": "Costa Rica",
    "zones": [
      {
        "id": "America/Costa_Rica",
        "region": ""
      }
    ]
  },
  {
    "code": "CI",
    "name": "Côte d’Ivoire",
    "zones": [
      {
        "id": "Africa/Abidjan",
        "region": ""
      }
    ]
  },
  {
    "code": "HR",
    "name": "Croatia",
    "zones": [
      {
        "id": "Europe/Zagreb",
        "region": ""
      }
    ]
  },
  {
    "code": "CU",
    "name": "Cuba",
    "zones": [
      {
        "id": "America/Havana",
        "region": ""
      }
    ]
  },
  {
    "code": "CW",
    "name": "Curaçao",
    "zones": [
      {
        "id": "America/Curacao",
        "region": ""
      }
    ]
  },
  {
    "code": "CY",
    "name": "Cyprus",
    "zones": [
      {
        "id": "Asia/Nicosia",
        "region": "most of Cyprus"
      },
      {
        "id": "Asia/Famagusta",
        "region": "Northern Cyprus"
      }
    ]
  },
  {
    "code": "CZ",
    "name": "Czech Republic",
    "zones": [
      {
        "id": "Europe/Prague",
        "region": ""
      }
    ]
  },
  {
    "code": "DK",
    "name": "Denmark",
    "zones": [
      {
        "id": "Europe/Copenhagen",
        "region": ""
      }
    ]
  },
  {
    "code": "DJ",
    "name": "Djibouti",
    "zones": [
      {
        "id": "Africa/Djibouti",
        "region": ""
      }
    ]
  },
  {
    "code": "DM",
    "name": "Dominica",
    "zones": [
      {
        "id": "America/Dominica",
        "region": ""
      }
    ]
  },
  {
    "code": "DO",
    "name": "Dominican Republic",
    "zones": [
      {
        "id": "America/Santo_Domingo",
        "region": ""
      }
    ]
  },
  {
    "code": "TL",
    "name": "East Timor",
    "zones": [
      {
        "id": "Asia/Dili",
        "region": ""
      }
    ]
  },
  {
    "code": "EC",
    "name": "Ecuador",
    "zones": [
      {
        "id": "America/Guayaquil",
        "region": "Ecuador (mainland)"
      },
      {
        "id": "Pacific/Galapagos",
        "region": "Galapagos Islands"
      }
    ]
  },
  {
    "code": "EG",
    "name": "Egypt",
    "zones": [
      {
        "id": "Africa/Cairo",
        "region": ""
      }
    ]
  },
  {
    "code": "SV",
    "name": "El Salvador",
    "zones": [
      {
        "id": "America/El_Salvador",
        "region": ""
      }
    ]
  },
  {
    "code": "GQ",
    "name": "Equatorial Guinea",
    "zones": [
      {
        "id": "Africa/Malabo",
        "region": ""
      }
    ]
  },
  {
    "code": "ER",
    "name": "Eritrea",
    "zones": [
      {
        "id": "Africa/Asmara",
        "region": ""
      }
    ]
  },
  {
    "code": "EE",
    "name": "Estonia",
    "zones": [
      {
        "id": "Europe/Tallinn",
        "region": ""
      }
    ]
  },
  {
    "code": "SZ",
    "name": "Eswatini (Swaziland)",
    "zones": [
      {
        "id": "Africa/Mbabane",
        "region": ""
      }
    ]
  },
  {
    "code": "ET",
    "name": "Ethiopia",
    "zones": [
      {
        "id": "Africa/Addis_Ababa",
        "region": ""
      }
    ]
  },
  {
    "code": "FK",
    "name": "Falkland Islands",
    "zones": [
      {
        "id": "Atlantic/Stanley",
        "region": ""
      }
    ]
  },
  {
    "code": "FO",
    "name": "Faroe Islands",
    "zones": [
      {
        "id": "Atlantic/Faroe",
        "region": ""
      }
    ]
  },
  {
    "code": "FJ",
    "name": "Fiji",
    "zones": [
      {
        "id": "Pacific/Fiji",
        "region": ""
      }
    ]
  },
  {
    "code": "FI",
    "name": "Finland",
    "zones": [
      {
        "id": "Europe/Helsinki",
        "region": ""
      }
    ]
  },
  {
    "code": "FR",
    "name": "France",
    "zones": [
      {
        "id": "Europe/Paris",
        "region": ""
      }
    ]
  },
  {
    "code": "GF",
    "name": "French Guiana",
    "zones": [
      {
        "id": "America/Cayenne",
        "region": ""
      }
    ]
  },
  {
    "code": "PF",
    "name": "French Polynesia",
    "zones": [
      {
        "id": "Pacific/Tahiti",
        "region": "Society Islands"
      },
      {
        "id": "Pacific/Marquesas",
        "region": "Marquesas Islands"
      },
      {
        "id": "Pacific/Gambier",
        "region": "Gambier Islands"
      }
    ]
  },
  {
    "code": "TF",
    "name": "French S. Terr.",
    "zones": [
      {
        "id": "Indian/Kerguelen",
        "region": ""
      }
    ]
  },
  {
    "code": "GA",
    "name": "Gabon",
    "zones": [
      {
        "id": "Africa/Libreville",
        "region": ""
      }
    ]
  },
  {
    "code": "GM",
    "name": "Gambia",
    "zones": [
      {
        "id": "Africa/Banjul",
        "region": ""
      }
    ]
  },
  {
    "code": "GE",
    "name": "Georgia",
    "zones": [
      {
        "id": "Asia/Tbilisi",
        "region": ""
      }
    ]
  },
  {
    "code": "DE",
    "name": "Germany",
    "zones": [
      {
        "id": "Europe/Berlin",
        "region": "most of Germany"
      },
      {
        "id": "Europe/Busingen",
        "region": "Busingen"
      }
    ]
  },
  {
    "code": "GH",
    "name": "Ghana",
    "zones": [
      {
        "id": "Africa/Accra",
        "region": ""
      }
    ]
  },
  {
    "code": "GI",
    "name": "Gibraltar",
    "zones": [
      {
        "id": "Europe/Gibraltar",
        "region": ""
      }
    ]
  },
  {
    "code": "GR",
    "name": "Greece",
    "zones": [
      {
        "id": "Europe/Athens",
        "region": ""
      }
    ]
  },
  {
    "code": "GL",
    "name": "Greenland",
    "zones": [
      {
        "id": "America/Nuuk",
        "region": "most of Greenland"
      },
      {
        "id": "America/Danmarkshavn",
        "region": "National Park (east coast)"
      },
      {
        "id": "America/Scoresbysund",
        "region": "Scoresbysund/Ittoqqortoormiit"
      },
      {
        "id": "America/Thule",
        "region": "Thule/Pituffik"
      }
    ]
  },
  {
    "code": "GD",
    "name": "Grenada",
    "zones": [
      {
        "id": "America/Grenada",
        "region": ""
      }
    ]
  },
  {
    "code": "GP",
    "name": "Guadeloupe",
    "zones": [
      {
        "id": "America/Guadeloupe",
        "region": ""
      }
    ]
  },
  {
    "code": "GU",
    "name": "Guam",
    "zones": [
      {
        "id": "Pacific/Guam",
        "region": ""
      }
    ]
  },
  {
    "code": "GT",
    "name": "Guatemala",
    "zones": [
      {
        "id": "America/Guatemala",
        "region": ""
      }
    ]
  },
  {
    "code": "GG",
    "name": "Guernsey",
    "zones": [
      {
        "id": "Europe/Guernsey",
        "region": ""
      }
    ]
  },
  {
    "code": "GN",
    "name": "Guinea",
    "zones": [
      {
        "id": "Africa/Conakry",
        "region": ""
      }
    ]
  },
  {
    "code": "GW",
    "name": "Guinea-Bissau",
    "zones": [
      {
        "id": "Africa/Bissau",
        "region": ""
      }
    ]
  },
  {
    "code": "GY",
    "name": "Guyana",
    "zones": [
      {
        "id": "America/Guyana",
        "region": ""
      }
    ]
  },
  {
    "code": "HT",
    "name": "Haiti",
    "zones": [
      {
        "id": "America/Port-au-Prince",
        "region": ""
      }
    ]
  },
  {
    "code": "HN",
    "name": "Honduras",
    "zones": [
      {
        "id": "America/Tegucigalpa",
        "region": ""
      }
    ]
  },
  {
    "code": "HK",
    "name": "Hong Kong",
    "zones": [
      {
        "id": "Asia/Hong_Kong",
        "region": ""
      }
    ]
  },
  {
    "code": "HU",
    "name": "Hungary",
    "zones": [
      {
        "id": "Europe/Budapest",
        "region": ""
      }
    ]
  },
  {
    "code": "IS",
    "name": "Iceland",
    "zones": [
      {
        "id": "Atlantic/Reykjavik",
        "region": ""
      }
    ]
  },
  {
    "code": "IN",
    "name": "India",
    "zones": [
      {
        "id": "Asia/Kolkata",
        "region": ""
      }
    ]
  },
  {
    "code": "ID",
    "name": "Indonesia",
    "zones": [
      {
        "id": "Asia/Jakarta",
        "region": "Java, Sumatra"
      },
      {
        "id": "Asia/Pontianak",
        "region": "Borneo (west, central)"
      },
      {
        "id": "Asia/Makassar",
        "region": "Borneo (east, south), Sulawesi/Celebes, Bali, Nusa Tengarra, Timor (west)"
      },
      {
        "id": "Asia/Jayapura",
        "region": "New Guinea (West Papua / Irian Jaya), Malukus/Moluccas"
      }
    ]
  },
  {
    "code": "IR",
    "name": "Iran",
    "zones": [
      {
        "id": "Asia/Tehran",
        "region": ""
      }
    ]
  },
  {
    "code": "IQ",
    "name": "Iraq",
    "zones": [
      {
        "id": "Asia/Baghdad",
        "region": ""
      }
    ]
  },
  {
    "code": "IE",
    "name": "Ireland",
    "zones": [
      {
        "id": "Europe/Dublin",
        "region": ""
      }
    ]
  },
  {
    "code": "IM",
    "name": "Isle of Man",
    "zones": [
      {
        "id": "Europe/Isle_of_Man",
        "region": ""
      }
    ]
  },
  {
    "code": "IL",
    "name": "Israel",
    "zones": [
      {
        "id": "Asia/Jerusalem",
        "region": ""
      }
    ]
  },
  {
    "code": "IT",
    "name": "Italy",
    "zones": [
      {
        "id": "Europe/Rome",
        "region": ""
      }
    ]
  },
  {
    "code": "JM",
    "name": "Jamaica",
    "zones": [
      {
        "id": "America/Jamaica",
        "region": ""
      }
    ]
  },
  {
    "code": "JP",
    "name": "Japan",
    "zones": [
      {
        "id": "Asia/Tokyo",
        "region": ""
      }
    ]
  },
  {
    "code": "JE",
    "name": "Jersey",
    "zones": [
      {
        "id": "Europe/Jersey",
        "region": ""
      }
    ]
  },
  {
    "code": "JO",
    "name": "Jordan",
    "zones": [
      {
        "id": "Asia/Amman",
        "region": ""
      }
    ]
  },
  {
    "code": "KZ",
    "name": "Kazakhstan",
    "zones": [
      {
        "id": "Asia/Almaty",
        "region": "most of Kazakhstan"
      },
      {
        "id": "Asia/Qyzylorda",
        "region": "Qyzylorda/Kyzylorda/Kzyl-Orda"
      },
      {
        "id": "Asia/Qostanay",
        "region": "Qostanay/Kostanay/Kustanay"
      },
      {
        "id": "Asia/Aqtobe",
        "region": "Aqtobe/Aktobe"
      },
      {
        "id": "Asia/Aqtau",
        "region": "Mangghystau/Mankistau"
      },
      {
        "id": "Asia/Atyrau",
        "region": "Atyrau/Atirau/Gur'yev"
      },
      {
        "id": "Asia/Oral",
        "region": "West Kazakhstan"
      }
    ]
  },
  {
    "code": "KE",
    "name": "Kenya",
    "zones": [
      {
        "id": "Africa/Nairobi",
        "region": ""
      }
    ]
  },
  {
    "code": "KI",
    "name": "Kiribati",
    "zones": [
      {
        "id": "Pacific/Tarawa",
        "region": "Gilbert Islands"
      },
      {
        "id": "Pacific/Kanton",
        "region": "Phoenix Islands"
      },
      {
        "id": "Pacific/Kiritimati",
        "region": "Line Islands"
      }
    ]
  },
  {
    "code": "KP",
    "name": "Korea (North)",
    "zones": [
      {
        "id": "Asia/Pyongyang",
        "region": ""
      }
    ]
  },
  {
    "code": "KR",
    "name": "Korea (South)",
    "zones": [
      {
        "id": "Asia/Seoul",
        "region": ""
      }
    ]
  },
  {
    "code": "KW",
    "name": "Kuwait",
    "zones": [
      {
        "id": "Asia/Kuwait",
        "region": ""
      }
    ]
  },
  {
    "code": "KG",
    "name": "Kyrgyzstan",
    "zones": [
      {
        "id": "Asia/Bishkek",
        "region": ""
      }
    ]
  },
  {
    "code": "LA",
    "name": "Laos",
    "zones": [
      {
        "id": "Asia/Vientiane",
        "region": ""
      }
    ]
  },
  {
    "code": "LV",
    "name": "Latvia",
    "zones": [
      {
        "id": "Europe/Riga",
        "region": ""
      }
    ]
  },
  {
    "code": "LB",
    "name": "Lebanon",
    "zones": [
      {
        "id": "Asia/Beirut",
        "region": ""
      }
    ]
  },
  {
    "code": "LS",
    "name": "Lesotho",
    "zones": [
      {
        "id": "Africa/Maseru",
        "region": ""
      }
    ]
  },
  {
    "code": "LR",
    "name": "Liberia",
    "zones": [
      {
        "id": "Africa/Monrovia",
        "region": ""
      }
    ]
  },
  {
    "code": "LY",
    "name": "Libya",
    "zones": [
      {
        "id": "Africa/Tripoli",
        "region": ""
      }
    ]
  },
  {
    "code": "LI",
    "name": "Liechtenstein",
    "zones": [
      {
        "id": "Europe/Vaduz",
        "region": ""
      }
    ]
  },
  {
    "code": "LT",
    "name": "Lithuania",
    "zones": [
      {
        "id": "Europe/Vilnius",
        "region": ""
      }
    ]
  },
  {
    "code": "LU",
    "name": "Luxembourg",
    "zones": [
      {
        "id": "Europe/Luxembourg",
        "region": ""
      }
    ]
  },
  {
    "code": "MO",
    "name": "Macau",
    "zones": [
      {
        "id": "Asia/Macau",
        "region": ""
      }
    ]
  },
  {
    "code": "MG",
    "name": "Madagascar",
    "zones": [
      {
        "id": "Indian/Antananarivo",
        "region": ""
      }
    ]
  },
  {
    "code": "MW",
    "name": "Malawi",
    "zones": [
      {
        "id": "Africa/Blantyre",
        "region": ""
      }
    ]
  },
  {
    "code": "MY",
    "name": "Malaysia",
    "zones": [
      {
        "id": "Asia/Kuala_Lumpur",
        "region": "Malaysia (peninsula)"
      },
      {
        "id": "Asia/Kuching",
        "region": "Sabah, Sarawak"
      }
    ]
  },
  {
    "code": "MV",
    "name": "Maldives",
    "zones": [
      {
        "id": "Indian/Maldives",
        "region": ""
      }
    ]
  },
  {
    "code": "ML",
    "name": "Mali",
    "zones": [
      {
        "id": "Africa/Bamako",
        "region": ""
      }
    ]
  },
  {
    "code": "MT",
    "name": "Malta",
    "zones": [
      {
        "id": "Europe/Malta",
        "region": ""
      }
    ]
  },
  {
    "code": "MH",
    "name": "Marshall Islands",
    "zones": [
      {
        "id": "Pacific/Majuro",
        "region": "most of Marshall Islands"
      },
      {
        "id": "Pacific/Kwajalein",
        "region": "Kwajalein"
      }
    ]
  },
  {
    "code": "MQ",
    "name": "Martinique",
    "zones": [
      {
        "id": "America/Martinique",
        "region": ""
      }
    ]
  },
  {
    "code": "MR",
    "name": "Mauritania",
    "zones": [
      {
        "id": "Africa/Nouakchott",
        "region": ""
      }
    ]
  },
  {
    "code": "MU",
    "name": "Mauritius",
    "zones": [
      {
        "id": "Indian/Mauritius",
        "region": ""
      }
    ]
  },
  {
    "code": "YT",
    "name": "Mayotte",
    "zones": [
      {
        "id": "Indian/Mayotte",
        "region": ""
      }
    ]
  },
  {
    "code": "MX",
    "name": "Mexico",
    "zones": [
      {
        "id": "America/Mexico_City",
        "region": "Central Mexico"
      },
      {
        "id": "America/Cancun",
        "region": "Quintana Roo"
      },
      {
        "id": "America/Merida",
        "region": "Campeche, Yucatan"
      },
      {
        "id": "America/Monterrey",
        "region": "Durango; Coahuila, Nuevo Leon, Tamaulipas (most areas)"
      },
      {
        "id": "America/Matamoros",
        "region": "Coahuila, Nuevo Leon, Tamaulipas (US border)"
      },
      {
        "id": "America/Chihuahua",
        "region": "Chihuahua (most areas)"
      },
      {
        "id": "America/Ciudad_Juarez",
        "region": "Chihuahua (US border - west)"
      },
      {
        "id": "America/Ojinaga",
        "region": "Chihuahua (US border - east)"
      },
      {
        "id": "America/Mazatlan",
        "region": "Baja California Sur, Nayarit (most areas), Sinaloa"
      },
      {
        "id": "America/Bahia_Banderas",
        "region": "Bahia de Banderas"
      },
      {
        "id": "America/Hermosillo",
        "region": "Sonora"
      },
      {
        "id": "America/Tijuana",
        "region": "Baja California"
      }
    ]
  },
  {
    "code": "FM",
    "name": "Micronesia",
    "zones": [
      {
        "id": "Pacific/Chuuk",
        "region": "Chuuk/Truk, Yap"
      },
      {
        "id": "Pacific/Pohnpei",
        "region": "Pohnpei/Ponape"
      },
      {
        "id": "Pacific/Kosrae",
        "region": "Kosrae"
      }
    ]
  },
  {
    "code": "MD",
    "name": "Moldova",
    "zones": [
      {
        "id": "Europe/Chisinau",
        "region": ""
      }
    ]
  },
  {
    "code": "MC",
    "name": "Monaco",
    "zones": [
      {
        "id": "Europe/Monaco",
        "region": ""
      }
    ]
  },
  {
    "code": "MN",
    "name": "Mongolia",
    "zones": [
      {
        "id": "Asia/Ulaanbaatar",
        "region": "most of Mongolia"
      },
      {
        "id": "Asia/Hovd",
        "region": "Bayan-Olgii, Hovd, Uvs"
      }
    ]
  },
  {
    "code": "ME",
    "name": "Montenegro",
    "zones": [
      {
        "id": "Europe/Podgorica",
        "region": ""
      }
    ]
  },
  {
    "code": "MS",
    "name": "Montserrat",
    "zones": [
      {
        "id": "America/Montserrat",
        "region": ""
      }
    ]
  },
  {
    "code": "MA",
    "name": "Morocco",
    "zones": [
      {
        "id": "Africa/Casablanca",
        "region": ""
      }
    ]
  },
  {
    "code": "MZ",
    "name": "Mozambique",
    "zones": [
      {
        "id": "Africa/Maputo",
        "region": ""
      }
    ]
  },
  {
    "code": "MM",
    "name": "Myanmar (Burma)",
    "zones": [
      {
        "id": "Asia/Yangon",
        "region": ""
      }
    ]
  },
  {
    "code": "NA",
    "name": "Namibia",
    "zones": [
      {
        "id": "Africa/Windhoek",
        "region": ""
      }
    ]
  },
  {
    "code": "NR",
    "name": "Nauru",
    "zones": [
      {
        "id": "Pacific/Nauru",
        "region": ""
      }
    ]
  },
  {
    "code": "NP",
    "name": "Nepal",
    "zones": [
      {
        "id": "Asia/Kathmandu",
        "region": ""
      }
    ]
  },
  {
    "code": "NL",
    "name": "Netherlands",
    "zones": [
      {
        "id": "Europe/Amsterdam",
        "region": ""
      }
    ]
  },
  {
    "code": "NC",
    "name": "New Caledonia",
    "zones": [
      {
        "id": "Pacific/Noumea",
        "region": ""
      }
    ]
  },
  {
    "code": "NZ",
    "name": "New Zealand",
    "zones": [
      {
        "id": "Pacific/Auckland",
        "region": "most of New Zealand"
      },
      {
        "id": "Pacific/Chatham",
        "region": "Chatham Islands"
      }
    ]
  },
  {
    "code": "NI",
    "name": "Nicaragua",
    "zones": [
      {
        "id": "America/Managua",
        "region": ""
      }
    ]
  },
  {
    "code": "NE",
    "name": "Niger",
    "zones": [
      {
        "id": "Africa/Niamey",
        "region": ""
      }
    ]
  },
  {
    "code": "NG",
    "name": "Nigeria",
    "zones": [
      {
        "id": "Africa/Lagos",
        "region": ""
      }
    ]
  },
  {
    "code": "NU",
    "name": "Niue",
    "zones": [
      {
        "id": "Pacific/Niue",
        "region": ""
      }
    ]
  },
  {
    "code": "NF",
    "name": "Norfolk Island",
    "zones": [
      {
        "id": "Pacific/Norfolk",
        "region": ""
      }
    ]
  },
  {
    "code": "MK",
    "name": "North Macedonia",
    "zones": [
      {
        "id": "Europe/Skopje",
        "region": ""
      }
    ]
  },
  {
    "code": "MP",
    "name": "Northern Mariana Islands",
    "zones": [
      {
        "id": "Pacific/Saipan",
        "region": ""
      }
    ]
  },
  {
    "code": "NO",
    "name": "Norway",
    "zones": [
      {
        "id": "Europe/Oslo",
        "region": ""
      }
    ]
  },
  {
    "code": "OM",
    "name": "Oman",
    "zones": [
      {
        "id": "Asia/Muscat",
        "region": ""
      }
    ]
  },
  {
    "code": "PK",
    "name": "Pakistan",
    "zones": [
      {
        "id": "Asia/Karachi",
        "region": ""
      }
    ]
  },
  {
    "code": "PW",
    "name": "Palau",
    "zones": [
      {
        "id": "Pacific/Palau",
        "region": ""
      }
    ]
  },
  {
    "code": "PS",
    "name": "Palestine",
    "zones": [
      {
        "id": "Asia/Gaza",
        "region": "Gaza Strip"
      },
      {
        "id": "Asia/Hebron",
        "region": "West Bank"
      }
    ]
  },
  {
    "code": "PA",
    "name": "Panama",
    "zones": [
      {
        "id": "America/Panama",
        "region": ""
      }
    ]
  },
  {
    "code": "PG",
    "name": "Papua New Guinea",
    "zones": [
      {
        "id": "Pacific/Port_Moresby",
        "region": "most of Papua New Guinea"
      },
      {
        "id": "Pacific/Bougainville",
        "region": "Bougainville"
      }
    ]
  },
  {
    "code": "PY",
    "name": "Paraguay",
    "zones": [
      {
        "id": "America/Asuncion",
        "region": ""
      }
    ]
  },
  {
    "code": "PE",
    "name": "Peru",
    "zones": [
      {
        "id": "America/Lima",
        "region": ""
      }
    ]
  },
  {
    "code": "PH",
    "name": "Philippines",
    "zones": [
      {
        "id": "Asia/Manila",
        "region": ""
      }
    ]
  },
  {
    "code": "PN",
    "name": "Pitcairn",
    "zones": [
      {
        "id": "Pacific/Pitcairn",
        "region": ""
      }
    ]
  },
  {
    "code": "PL",
    "name": "Poland",
    "zones": [
      {
        "id": "Europe/Warsaw",
        "region": ""
      }
    ]
  },
  {
    "code": "PT",
    "name": "Portugal",
    "zones": [
      {
        "id": "Europe/Lisbon",
        "region": "Portugal (mainland)"
      },
      {
        "id": "Atlantic/Madeira",
        "region": "Madeira Islands"
      },
      {
        "id": "Atlantic/Azores",
        "region": "Azores"
      }
    ]
  },
  {
    "code": "PR",
    "name": "Puerto Rico",
    "zones": [
      {
        "id": "America/Puerto_Rico",
        "region": ""
      }
    ]
  },
  {
    "code": "QA",
    "name": "Qatar",
    "zones": [
      {
        "id": "Asia/Qatar",
        "region": ""
      }
    ]
  },
  {
    "code": "RE",
    "name": "Réunion",
    "zones": [
      {
        "id": "Indian/Reunion",
        "region": ""
      }
    ]
  },
  {
    "code": "RO",
    "name": "Romania",
    "zones": [
      {
        "id": "Europe/Bucharest",
        "region": ""
      }
    ]
  },
  {
    "code": "RU",
    "name": "Russia",
    "zones": [
      {
        "id": "Europe/Kaliningrad",
        "region": "MSK-01 - Kaliningrad"
      },
      {
        "id": "Europe/Moscow",
        "region": "MSK+00 - Moscow area"
      },
      {
        "id": "Europe/Kirov",
        "region": "MSK+00 - Kirov"
      },
      {
        "id": "Europe/Volgograd",
        "region": "MSK+00 - Volgograd"
      },
      {
        "id": "Europe/Astrakhan",
        "region": "MSK+01 - Astrakhan"
      },
      {
        "id": "Europe/Saratov",
        "region": "MSK+01 - Saratov"
      },
      {
        "id": "Europe/Ulyanovsk",
        "region": "MSK+01 - Ulyanovsk"
      },
      {
        "id": "Europe/Samara",
        "region": "MSK+01 - Samara, Udmurtia"
      },
      {
        "id": "Asia/Yekaterinburg",
        "region": "MSK+02 - Urals"
      },
      {
        "id": "Asia/Omsk",
        "region": "MSK+03 - Omsk"
      },
      {
        "id": "Asia/Novosibirsk",
        "region": "MSK+04 - Novosibirsk"
      },
      {
        "id": "Asia/Barnaul",
        "region": "MSK+04 - Altai"
      },
      {
        "id": "Asia/Tomsk",
        "region": "MSK+04 - Tomsk"
      },
      {
        "id": "Asia/Novokuznetsk",
        "region": "MSK+04 - Kemerovo"
      },
      {
        "id": "Asia/Krasnoyarsk",
        "region": "MSK+04 - Krasnoyarsk area"
      },
      {
        "id": "Asia/Irkutsk",
        "region": "MSK+05 - Irkutsk, Buryatia"
      },
      {
        "id": "Asia/Chita",
        "region": "MSK+06 - Zabaykalsky"
      },
      {
        "id": "Asia/Yakutsk",
        "region": "MSK+06 - Lena River"
      },
      {
        "id": "Asia/Khandyga",
        "region": "MSK+06 - Tomponsky, Ust-Maysky"
      },
      {
        "id": "Asia/Vladivostok",
        "region": "MSK+07 - Amur River"
      },
      {
        "id": "Asia/Ust-Nera",
        "region": "MSK+07 - Oymyakonsky"
      },
      {
        "id": "Asia/Magadan",
        "region": "MSK+08 - Magadan"
      },
      {
        "id": "Asia/Sakhalin",
        "region": "MSK+08 - Sakhalin Island"
      },
      {
        "id": "Asia/Srednekolymsk",
        "region": "MSK+08 - Sakha (E), N Kuril Is"
      },
      {
        "id": "Asia/Kamchatka",
        "region": "MSK+09 - Kamchatka"
      },
      {
        "id": "Asia/Anadyr",
        "region": "MSK+09 - Bering Sea"
      }
    ]
  },
  {
    "code": "RW",
    "name": "Rwanda",
    "zones": [
      {
        "id": "Africa/Kigali",
        "region": ""
      }
    ]
  },
  {
    "code": "AS",
    "name": "Samoa (American)",
    "zones": [
      {
        "id": "Pacific/Pago_Pago",
        "region": ""
      }
    ]
  },
  {
    "code": "WS",
    "name": "Samoa (western)",
    "zones": [
      {
        "id": "Pacific/Apia",
        "region": ""
      }
    ]
  },
  {
    "code": "SM",
    "name": "San Marino",
    "zones": [
      {
        "id": "Europe/San_Marino",
        "region": ""
      }
    ]
  },
  {
    "code": "ST",
    "name": "Sao Tome & Principe",
    "zones": [
      {
        "id": "Africa/Sao_Tome",
        "region": ""
      }
    ]
  },
  {
    "code": "SA",
    "name": "Saudi Arabia",
    "zones": [
      {
        "id": "Asia/Riyadh",
        "region": ""
      }
    ]
  },
  {
    "code": "SN",
    "name": "Senegal",
    "zones": [
      {
        "id": "Africa/Dakar",
        "region": ""
      }
    ]
  },
  {
    "code": "RS",
    "name": "Serbia",
    "zones": [
      {
        "id": "Europe/Belgrade",
        "region": ""
      }
    ]
  },
  {
    "code": "SC",
    "name": "Seychelles",
    "zones": [
      {
        "id": "Indian/Mahe",
        "region": ""
      }
    ]
  },
  {
    "code": "SL",
    "name": "Sierra Leone",
    "zones": [
      {
        "id": "Africa/Freetown",
        "region": ""
      }
    ]
  },
  {
    "code": "SG",
    "name": "Singapore",
    "zones": [
      {
        "id": "Asia/Singapore",
        "region": ""
      }
    ]
  },
  {
    "code": "SK",
    "name": "Slovakia",
    "zones": [
      {
        "id": "Europe/Bratislava",
        "region": ""
      }
    ]
  },
  {
    "code": "SI",
    "name": "Slovenia",
    "zones": [
      {
        "id": "Europe/Ljubljana",
        "region": ""
      }
    ]
  },
  {
    "code": "SB",
    "name": "Solomon Islands",
    "zones": [
      {
        "id": "Pacific/Guadalcanal",
        "region": ""
      }
    ]
  },
  {
    "code": "SO",
    "name": "Somalia",
    "zones": [
      {
        "id": "Africa/Mogadishu",
        "region": ""
      }
    ]
  },
  {
    "code": "ZA",
    "name": "South Africa",
    "zones": [
      {
        "id": "Africa/Johannesburg",
        "region": ""
      }
    ]
  },
  {
    "code": "GS",
    "name": "South Georgia & the South Sandwich Islands",
    "zones": [
      {
        "id": "Atlantic/South_Georgia",
        "region": ""
      }
    ]
  },
  {
    "code": "SS",
    "name": "South Sudan",
    "zones": [
      {
        "id": "Africa/Juba",
        "region": ""
      }
    ]
  },
  {
    "code": "ES",
    "name": "Spain",
    "zones": [
      {
        "id": "Europe/Madrid",
        "region": "Spain (mainland)"
      },
      {
        "id": "Africa/Ceuta",
        "region": "Ceuta, Melilla"
      },
      {
        "id": "Atlantic/Canary",
        "region": "Canary Islands"
      }
    ]
  },
  {
    "code": "LK",
    "name": "Sri Lanka",
    "zones": [
      {
        "id": "Asia/Colombo",
        "region": ""
      }
    ]
  },
  {
    "code": "BL",
    "name": "St Barthelemy",
    "zones": [
      {
        "id": "America/St_Barthelemy",
        "region": ""
      }
    ]
  },
  {
    "code": "SH",
    "name": "St Helena",
    "zones": [
      {
        "id": "Atlantic/St_Helena",
        "region": ""
      }
    ]
  },
  {
    "code": "KN",
    "name": "St Kitts & Nevis",
    "zones": [
      {
        "id": "America/St_Kitts",
        "region": ""
      }
    ]
  },
  {
    "code": "LC",
    "name": "St Lucia",
    "zones": [
      {
        "id": "America/St_Lucia",
        "region": ""
      }
    ]
  },
  {
    "code": "SX",
    "name": "St Maarten (Dutch)",
    "zones": [
      {
        "id": "America/Lower_Princes",
        "region": ""
      }
    ]
  },
  {
    "code": "MF",
    "name": "St Martin (French)",
    "zones": [
      {
        "id": "America/Marigot",
        "region": ""
      }
    ]
  },
  {
    "code": "PM",
    "name": "St Pierre & Miquelon",
    "zones": [
      {
        "id": "America/Miquelon",
        "region": ""
      }
    ]
  },
  {
    "code": "VC",
    "name": "St Vincent",
    "zones": [
      {
        "id": "America/St_Vincent",
        "region": ""
      }
    ]
  },
  {
    "code": "SD",
    "name": "Sudan",
    "zones": [
      {
        "id": "Africa/Khartoum",
        "region": ""
      }
    ]
  },
  {
    "code": "SR",
    "name": "Suriname",
    "zones": [
      {
        "id": "America/Paramaribo",
        "region": ""
      }
    ]
  },
  {
    "code": "SJ",
    "name": "Svalbard & Jan Mayen",
    "zones": [
      {
        "id": "Arctic/Longyearbyen",
        "region": ""
      }
    ]
  },
  {
    "code": "SE",
    "name": "Sweden",
    "zones": [
      {
        "id": "Europe/Stockholm",
        "region": ""
      }
    ]
  },
  {
    "code": "CH",
    "name": "Switzerland",
    "zones": [
      {
        "id": "Europe/Zurich",
        "region": ""
      }
    ]
  },
  {
    "code": "SY",
    "name": "Syria",
    "zones": [
      {
        "id": "Asia/Damascus",
        "region": ""
      }
    ]
  },
  {
    "code": "TW",
    "name": "Taiwan",
    "zones": [
      {
        "id": "Asia/Taipei",
        "region": ""
      }
    ]
  },
  {
    "code": "TJ",
    "name": "Tajikistan",
    "zones": [
      {
        "id": "Asia/Dushanbe",
        "region": ""
      }
    ]
  },
  {
    "code": "TZ",
    "name": "Tanzania",
    "zones": [
      {
        "id": "Africa/Dar_es_Salaam",
        "region": ""
      }
    ]
  },
  {
    "code": "TH",
    "name": "Thailand",
    "zones": [
      {
        "id": "Asia/Bangkok",
        "region": ""
      }
    ]
  },
  {
    "code": "TG",
    "name": "Togo",
    "zones": [
      {
        "id": "Africa/Lome",
        "region": ""
      }
    ]
  },
  {
    "code": "TK",
    "name": "Tokelau",
    "zones": [
      {
        "id": "Pacific/Fakaofo",
        "region": ""
      }
    ]
  },
  {
    "code": "TO",
    "name": "Tonga",
    "zones": [
      {
        "id": "Pacific/Tongatapu",
        "region": ""
      }
    ]
  },
  {
    "code": "TT",
    "name": "Trinidad & Tobago",
    "zones": [
      {
        "id": "America/Port_of_Spain",
        "region": ""
      }
    ]
  },
  {
    "code": "TN",
    "name": "Tunisia",
    "zones": [
      {
        "id": "Africa/Tunis",
        "region": ""
      }
    ]
  },
  {
    "code": "TR",
    "name": "Turkey",
    "zones": [
      {
        "id": "Europe/Istanbul",
        "region": ""
      }
    ]
  },
  {
    "code": "TM",
    "name": "Turkmenistan",
    "zones": [
      {
        "id": "Asia/Ashgabat",
        "region": ""
      }
    ]
  },
  {
    "code": "TC",
    "name": "Turks & Caicos Is",
    "zones": [
      {
        "id": "America/Grand_Turk",
        "region": ""
      }
    ]
  },
  {
    "code": "TV",
    "name": "Tuvalu",
    "zones": [
      {
        "id": "Pacific/Funafuti",
        "region": ""
      }
    ]
  },
  {
    "code": "UG",
    "name": "Uganda",
    "zones": [
      {
        "id": "Africa/Kampala",
        "region": ""
      }
    ]
  },
  {
    "code": "UA",
    "name": "Ukraine",
    "zones": [
      {
        "id": "Europe/Simferopol",
        "region": "Crimea"
      },
      {
        "id": "Europe/Kyiv",
        "region": "most of Ukraine"
      }
    ]
  },
  {
    "code": "AE",
    "name": "United Arab Emirates",
    "zones": [
      {
        "id": "Asia/Dubai",
        "region": ""
      }
    ]
  },
  {
    "code": "US",
    "name": "United States",
    "zones": [
      {
        "id": "America/New_York",
        "region": "Eastern (most areas)"
      },
      {
        "id": "America/Detroit",
        "region": "Eastern - MI (most areas)"
      },
      {
        "id": "America/Kentucky/Louisville",
        "region": "Eastern - KY (Louisville area)"
      },
      {
        "id": "America/Kentucky/Monticello",
        "region": "Eastern - KY (Wayne)"
      },
      {
        "id": "America/Indiana/Indianapolis",
        "region": "Eastern - IN (most areas)"
      },
      {
        "id": "America/Indiana/Vincennes",
        "region": "Eastern - IN (Da, Du, K, Mn)"
      },
      {
        "id": "America/Indiana/Winamac",
        "region": "Eastern - IN (Pulaski)"
      },
      {
        "id": "America/Indiana/Marengo",
        "region": "Eastern - IN (Crawford)"
      },
      {
        "id": "America/Indiana/Petersburg",
        "region": "Eastern - IN (Pike)"
      },
      {
        "id": "America/Indiana/Vevay",
        "region": "Eastern - IN (Switzerland)"
      },
      {
        "id": "America/Chicago",
        "region": "Central (most areas)"
      },
      {
        "id": "America/Indiana/Tell_City",
        "region": "Central - IN (Perry)"
      },
      {
        "id": "America/Indiana/Knox",
        "region": "Central - IN (Starke)"
      },
      {
        "id": "America/Menominee",
        "region": "Central - MI (Wisconsin border)"
      },
      {
        "id": "America/North_Dakota/Center",
        "region": "Central - ND (Oliver)"
      },
      {
        "id": "America/North_Dakota/New_Salem",
        "region": "Central - ND (Morton rural)"
      },
      {
        "id": "America/North_Dakota/Beulah",
        "region": "Central - ND (Mercer)"
      },
      {
        "id": "America/Denver",
        "region": "Mountain (most areas)"
      },
      {
        "id": "America/Boise",
        "region": "Mountain - ID (south), OR (east)"
      },
      {
        "id": "America/Phoenix",
        "region": "MST - AZ (except Navajo)"
      },
      {
        "id": "America/Los_Angeles",
        "region": "Pacific"
      },
      {
        "id": "America/Anchorage",
        "region": "Alaska (most areas)"
      },
      {
        "id": "America/Juneau",
        "region": "Alaska - Juneau area"
      },
      {
        "id": "America/Sitka",
        "region": "Alaska - Sitka area"
      },
      {
        "id": "America/Metlakatla",
        "region": "Alaska - Annette Island"
      },
      {
        "id": "America/Yakutat",
        "region": "Alaska - Yakutat"
      },
      {
        "id": "America/Nome",
        "region": "Alaska (west)"
      },
      {
        "id": "America/Adak",
        "region": "Alaska - western Aleutians"
      },
      {
        "id": "Pacific/Honolulu",
        "region": "Hawaii"
      }
    ]
  },
  {
    "code": "UY",
    "name": "Uruguay",
    "zones": [
      {
        "id": "America/Montevideo",
        "region": ""
      }
    ]
  },
  {
    "code": "UM",
    "name": "US minor outlying islands",
    "zones": [
      {
        "id": "Pacific/Midway",
        "region": "Midway Islands"
      },
      {
        "id": "Pacific/Wake",
        "region": "Wake Island"
      }
    ]
  },
  {
    "code": "UZ",
    "name": "Uzbekistan",
    "zones": [
      {
        "id": "Asia/Samarkand",
        "region": "Uzbekistan (west)"
      },
      {
        "id": "Asia/Tashkent",
        "region": "Uzbekistan (east)"
      }
    ]
  },
  {
    "code": "VU",
    "name": "Vanuatu",
    "zones": [
      {
        "id": "Pacific/Efate",
        "region": ""
      }
    ]
  },
  {
    "code": "VA",
    "name": "Vatican City",
    "zones": [
      {
        "id": "Europe/Vatican",
        "region": ""
      }
    ]
  },
  {
    "code": "VE",
    "name": "Venezuela",
    "zones": [
      {
        "id": "America/Caracas",
        "region": ""
      }
    ]
  },
  {
    "code": "VN",
    "name": "Vietnam",
    "zones": [
      {
        "id": "Asia/Ho_Chi_Minh",
        "region": ""
      }
    ]
  },
  {
    "code": "VG",
    "name": "Virgin Islands (UK)",
    "zones": [
      {
        "id": "America/Tortola",
        "region": ""
      }
    ]
  },
  {
    "code": "VI",
    "name": "Virgin Islands (US)",
    "zones": [
      {
        "id": "America/St_Thomas",
        "region": ""
      }
    ]
  },
  {
    "code": "WF",
    "name": "Wallis & Futuna",
    "zones": [
      {
        "id": "Pacific/Wallis",
        "region": ""
      }
    ]
  },
  {
    "code": "EH",
    "name": "Western Sahara",
    "zones": [
      {
        "id": "Africa/El_Aaiun",
        "region": ""
      }
    ]
  },
  {
    "code": "YE",
    "name": "Yemen",
    "zones": [
      {
        "id": "Asia/Aden",
        "region": ""
      }
    ]
  },
  {
    "code": "ZM",
    "name": "Zambia",
    "zones": [
      {
        "id": "Africa/Lusaka",
        "region": ""
      }
    ]
  },
  {
    "code": "ZW",
    "name": "Zimbabwe",
    "zones": [
      {
        "id": "Africa/Harare",
        "region": ""
      }
    ]
  }
];

/** Every zone we offer, to the country that files it. Built once, read often. */
export const COUNTRY_OF_ZONE: ReadonlyMap<string, string> = new Map(
  COUNTRY_ZONES.flatMap((c) => c.zones.map((z) => [z.id, c.code] as const)),
);
